import React from 'react';
import { Maximize2, Clock, Monitor, CheckSquare } from 'lucide-react';
import SectionHeading from './SectionHeading';
import GreenButton from './GreenButton';
import Reveal from './Reveal';
import { useContactModal } from '../../contexts/ContactModalContext';

const features = [
  { icon: Maximize2, title: 'Made to order', text: 'Mix and match products with bespoke customisation to meet your spec.' },
  { icon: Clock, title: 'Fast turn around', text: 'In-house production with express service if needed to hit your deadline.' },
  { icon: Monitor, title: 'In-house design', text: 'Artwork created from scratch or finalised from your designs, ready for print.' },
  { icon: CheckSquare, title: 'Trusted materials', text: 'Working with tried & tested brands to ensure longevity on every project.' },
];

const AboutOutpost: React.FC = () => {
  const { openContactModal } = useContactModal();

  return (
    <section className="bg-white text-black py-20 md:py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionHeading
            title="We are Customisation Specialists"
            subtitle="Based in Worcestershire • Delivering across the UK"
            tone="green"
            size="compact"
            rules={false}
          />
        </Reveal>

        <Reveal delay={100} className="mt-12 max-w-3xl mx-auto text-center">
          <h3 className="font-montserrat font-extrabold text-2xl md:text-[28px] tracking-tight mb-5">
            Let&apos;s talk about your next project.
          </h3>
          <p className="font-poppins text-base leading-7 text-black/80">
            Chat to our team who can recommend the products and services that best suit your project,
            budget and deadline. We will guide you through every stage of the process until we finalise
            the custom signage, print and clothing you&apos;ve dreamed of.
          </p>
          <div className="mt-8">
            <GreenButton onClick={openContactModal}>Get in touch</GreenButton>
          </div>
        </Reveal>

        <div className="mt-16 pt-12 border-t border-black/10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 80} className="flex gap-4 items-start">
              <Icon className="w-6 h-6 shrink-0 text-[#78BE20] mt-0.5" strokeWidth={2} />
              <div>
                <h4 className="font-montserrat font-bold text-[13px] uppercase tracking-[0.05em] mb-1">{title}</h4>
                <p className="font-poppins text-sm leading-6 text-black/70">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutOutpost;
